var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { FolderService } from '@/domains/detail/folder/types/folder-service.interface';
export const CollaborationServiceSymbol = Symbol.for('CollaborationService');
let CollaborationService = class CollaborationService {
    constructor(folderService) {
        this.folderService = folderService;
        this.changeShareSettingVisible = false;
        this.selectedRow = null;
        this.selectNodeId = '-root';
        this.selectNode = null;
        this.selectedId = '';
        this.selectedType = '';
        this.selectNodeId = this.folderService.folderInfo?.folder_id || '-root';
    }
    openChangeShareSettingDialog(row) {
        this.selectedRow = row;
        this.changeShareSettingVisible = true;
    }
    closeChangeShareSettingDialog() {
        this.selectedRow = null;
        this.changeShareSettingVisible = false;
    }
};
CollaborationService = __decorate([
    injectable(),
    __param(0, inject(FolderService)),
    __metadata("design:paramtypes", [typeof (_a = typeof FolderService !== "undefined" && FolderService) === "function" ? _a : Object])
], CollaborationService);
export { CollaborationService };
